module.exports = __webpack_public_path__ + "img/2010-1.bd3e46e8.jpeg";